import styled from 'styled-components';

export const LinkBox = styled.a`
  color: #1777E5;
  text-decoration: none;

  &:hover {
    color: #1A85FF;
    text-decoration: underline;
  }

  &:active {
    color: #005FCC;
  }
`;

LinkBox.displayName = 'LinkBox';
